import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  forwardRef,
  memo,
  useImperativeHandle,
} from "react";
import moment from "moment";
import ListPageHeader from "../utilities/ListPageHeader";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
  Box,
  TextField,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "./DatepickerEditorComponent";
import { toast } from "react-toastify";
import {
  CustomerIdEditorComponent,
  MultipleOrderCategoryEditorComponent,
  MultipleVendorEditorComponent,
} from "./SelectEditorComponent";
import CustomDatePicker from "../utilities/CustomDatePicker";
const NumericCellEditor = memo(
  forwardRef((props, ref) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState(props.value ?? "");

    useEffect(() => {
      inputRef.current?.focus();
      inputRef.current?.select();
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return value === "" ? null : Number(value);
      },

      focusIn() {
        inputRef.current?.focus();
        inputRef.current?.select();
      },
    }));

    const handleChange = (e) => {
      setValue(e.target.value);
    };
    const handleKeyDown = (e) => {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        ".",
      ];

      if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    };

    const cellStyle =
      typeof props.colDef?.cellStyle === "function"
        ? props.colDef.cellStyle(props)
        : props.colDef?.cellStyle || {};

    return (
      <TextField
        autoFocus
        fullWidth
        type="text"
        variant="outlined"
        value={value}
        inputRef={inputRef}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "100%",
            backgroundColor: cellStyle.backgroundColor,
            color: cellStyle.color,
            borderRadius: 0,
            paddingBottom: "2px",
            transition: "background-color 0.15s ease",
          },
          "& .MuiInputBase-input": {
            color: cellStyle.color,
            textAlign: "left",
            padding: "8px",
          },
          "& fieldset": {
            border: "none",
          },
        }}
      />
    );
  }),
);
const VendorPriceIncrease = () => {
  const priceIncreaseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.vendorPriceIncrease}`;
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [rowData, setRowData] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  const [vendorOptions, setVendorOptions] = useState([]);
  const vendorOptionsRef = useRef([]);
  const customerOptionsRef = useRef([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [fromDate, setFromDate] = useState(
    moment().startOf("year").format("YYYY-MM-DD"),
  );

  const [toDate, setToDate] = useState(
    moment().endOf("year").format("YYYY-MM-DD"),
  );

  const showDiscountPercent = (props) => {
    const value = props.value ?? 0;
    return <p>{Number(value).toFixed(3)}%</p>;
  };
  const formatApiDate = (date) => moment(date).format("YYYY-MM-DD");
  const handleDateFormat = (props) =>
    props?.value ? moment(props?.value).format("DD-MM-YYYY") : "";

  const onSelectionChanged = useCallback(() => {
    const rows = gridRef.current.api.getSelectedRows();
    setSelectedRows(rows);
  }, []);
  useEffect(() => {
    const loadVendors = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;

      try {
        const vendors = await OAuthService.getList(url);

        const result =
          vendors?.data?._embedded?.factoryVendors?.map((v) => ({
            label: v.name,
            value: v.id,
          })) || [];

        const optionsWithAll = [{ value: "ALL", label: "ALL" }, ...result];
        setVendorOptions(optionsWithAll);
        vendorOptionsRef.current = optionsWithAll;
      } catch (error) {
        console.error("Vendor fetch error:", error);
      }
    };

    loadVendors();
  }, []);
  const handleAddRow = () => {
    if (!gridApi) return;

    const newRow = {
      customerId: "",
      vendorId: [],
      orderCategories: "",
      validFrom: "",
      validTo: "",
      wg1PayablePriceIncrease: 0,
      wg2PayablePriceIncrease: 0,

      isNew: true,
    };

    let addIndex = rowData?.length;
    const selectedNodes = gridApi.getSelectedNodes();

    if (selectedNodes && selectedNodes.length > 0) {
      const selectedNode = selectedNodes[0];
      addIndex = selectedNode.rowIndex + 1;
    }

    const res = gridApi.applyTransaction({
      add: [newRow],
      addIndex,
    });

    setRowData((prev) => {
      const updated = [...(prev || [])];
      updated.splice(addIndex, 0, newRow);
      return updated;
    });

    if (res.add && res.add.length > 0) {
      const newRowNode = res?.add[0];

      setTimeout(() => {
        gridApi.stopEditing();
        gridApi.setFocusedCell(newRowNode.rowIndex, "customerId");
        gridApi.startEditingCell({
          rowIndex: newRowNode.rowIndex,
          colKey: "customerId",
        });
      }, 100);
    }
  };
  const startEditRow = useCallback((rowNode) => {
    if (!rowNode) return;

    const index = rowNode.rowIndex;

    gridRef.current.api.setFocusedCell(index, "customerId");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "customerId",
    });
  }, []);

  const handleEditRow = useCallback(() => {
    const selected = gridRef.current.api.getSelectedNodes();

    if (!selected.length) return;

    if (selected.length > 1) {
      toast.warning("Please select only one row to edit.");
      return;
    }

    startEditRow(selected[0]);
  }, [startEditRow]);

  const handleSaveDiscount = async () => {
    gridApi.stopEditing();

    try {
      const changedRows = rowData.filter((row) => row.isNew || row.isEdited);

      if (changedRows.length === 0) {
        toast.info("No new or updated price increases to save.");
        setSaveOpen(false);
        return;
      }

      const selectedIds = new Set(
        (selectedRows || []).map((row) => row.id ?? row),
      );
      const unselectedChangedRows = changedRows.filter(
        (row) => !selectedIds.has(row.id ?? row),
      );

      if (
        !selectedRows ||
        selectedRows.length === 0 ||
        unselectedChangedRows.length > 0
      ) {
        toast.warning("Please select the updated records before saving.");
        setSaveOpen(false);
        return;
      }

      const rowsToSave = selectedRows.filter(
        (row) => row.isNew || row.isEdited,
      );

      const newRows = rowsToSave.filter((row) => row.isNew);

      const updatedRows = rowsToSave.filter(
        (row) => row.isEdited && !row.isNew,
      );

      const invalidRows = rowsToSave.filter((row) => !isRowValid(row));
      if (invalidRows.length > 0) {
        toast.warning("Please fill all required fields before saving.");
        setSaveOpen(false);
        return;
      }

      for (const row of newRows) {
        const payload = {
          vendorId: Array.isArray(row.vendorId)
            ? row.vendorId
            : row.vendorId
            ? [row.vendorId]
            : [],
          customerId: row.customerId || 0,
          validFrom: row.validFrom
            ? moment(row.validFrom).format("YYYY-MM-DD")
            : null,
          validTo: row.validTo
            ? moment(row.validTo).format("YYYY-MM-DD")
            : null,
          wg1PayablePriceIncrease: Number(row.wg1PayablePriceIncrease) || 0,
          wg2PayablePriceIncrease: Number(row.wg2PayablePriceIncrease) || 0,

          orderCategories: Array.isArray(row.orderCategories)
            ? row.orderCategories
            : row.orderCategories
            ? [row.orderCategories]
            : [],
        };

        await OAuthService.addData(priceIncreaseUrl, payload);
      }

      for (const row of updatedRows) {
        const payload = {
          customerId: row.customerId || 0,
          vendorId: Array.isArray(row.vendorId)
            ? row.vendorId
            : row.vendorId
            ? [row.vendorId]
            : [],
          validFrom: row.validFrom
            ? moment(row.validFrom).format("YYYY-MM-DD")
            : null,
          validTo: row.validTo
            ? moment(row.validTo).format("YYYY-MM-DD")
            : null,
          wg1PayablePriceIncrease: Number(row.wg1PayablePriceIncrease) || 0,
          wg2PayablePriceIncrease: Number(row.wg2PayablePriceIncrease) || 0,
          orderCategories: Array.isArray(row.orderCategories)
            ? row.orderCategories
            : row.orderCategories
            ? [row.orderCategories]
            : [],
        };

        await OAuthService.updateData(priceIncreaseUrl, row.id, payload);
      }

      await loadPriceIncrease();
      toast.success("Price increases saved successfully!");
      setSaveOpen(false);
      setIsSaveEnabled(false);
      setSelectedRows([]);
    } catch (err) {
      console.error("Error saving price increases:", err);
      toast.error("Failed to save price increases.");
      setSaveOpen(false);
      setIsSaveEnabled(false);
      setSelectedRows([]);
    }
  };

  const isDiscountInRange = (v) => {
    const n = Number(v ?? 0);
    return !isNaN(n) && n >= 0 && n <= 100;
  };

  const onCellValueChanged = (params) => {
    const { colDef, newValue, node } = params;

    let value = newValue;

    const numericFields = [
      "wg1PayablePriceIncrease",
      "wg2PayablePriceIncrease",
    ];

    if (numericFields.includes(colDef.field)) {
      value = Number(newValue);

      if (isNaN(value) || value < 0) {
        toast.warning(`${colDef.headerName} cannot be negative`, {
          toastId: `${colDef.field}-range`,
        });
        value = 0;
      } else if (value > 100) {
        toast.warning(`${colDef.headerName} cannot exceed 100`, {
          toastId: `${colDef.field}-range`,
        });
        value = 100;
      }

      node.setDataValue(colDef.field, value);
    }

    node.data.isEdited = !node.data.isNew;

    if (!node.isSelected()) {
      node.setSelected(true);
    }

    validateSaveButton();
  };

  const isRowValid = (row) => {
    const hasRequiredFields =
      row.customerId &&
      Array.isArray(row.vendorId) &&
      row.vendorId.length > 0 &&
      row.validFrom &&
      row.validTo;

    const hasOrderCategory =
      Array.isArray(row.orderCategories) && row.orderCategories.length > 0;

    const hasPositiveValue =
      isDiscountInRange(row.wg1PayablePriceIncrease) &&
      isDiscountInRange(row.wg2PayablePriceIncrease);

    return hasRequiredFields && hasOrderCategory && hasPositiveValue;
  };
  const validateSaveButton = useCallback(() => {
    const changedRows = rowData.filter(isRowChanged);

    if (changedRows.length === 0) {
      setIsSaveEnabled(false);
      return;
    }

    const selectedIds = new Set(
      (selectedRows || []).map((row) => row.id ?? row),
    );
    const allChangedRowsSelected = changedRows.every((row) =>
      selectedIds.has(row.id ?? row),
    );

    setIsSaveEnabled(allChangedRowsSelected && changedRows.every(isRowValid));
  }, [rowData, selectedRows]);
  useEffect(() => {
    validateSaveButton();
  }, [selectedRows, validateSaveButton]);
  const isRowChanged = (row) => row.isNew || row.isEdited;
  const handlePasteEnd = useCallback(() => {
    const api = gridRef.current?.api;
    if (!api) return;

    api.forEachNode((node) => {
      if ((node.data?.isNew || node.data?.isEdited) && !node.isSelected()) {
        node.setSelected(true, false);
      }
    });

    validateSaveButton();
  }, [validateSaveButton]);

  const handleDeleteDiscount = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.info("Please select one or more price increases to delete.");
      return;
    }

    try {
      const newRows = selectedRows.filter((row) => !row.id);
      const existingRows = selectedRows.filter((row) => row.id);

      if (newRows?.length > 0) {
        gridRef.current.api.applyTransaction({
          remove: newRows,
        });
      }

      if (existingRows.length > 0) {
        const results = await Promise.allSettled(
          existingRows.map((row) =>
            OAuthService.deleteData(priceIncreaseUrl, row.id),
          ),
        );

        const succeededRows = existingRows.filter(
          (_, index) => results[index].status === "fulfilled",
        );
        const failedRows = existingRows.filter(
          (_, index) => results[index].status === "rejected",
        );

        if (succeededRows.length > 0) {
          gridRef.current.api.applyTransaction({
            remove: succeededRows,
          });
        }

        if (failedRows.length > 0) {
          toast.error(
            `Failed to delete ${failedRows.length} of ${existingRows.length} price increase(s). Please try again.`,
          );
        } else {
          toast.success("Selected price increases deleted successfully!");
        }
      } else {
        toast.success("Selected price increases deleted successfully!");
      }

      await loadPriceIncrease();

      setDeleteOpen(false);
      setSelectedRows([]);
      setIsSaveEnabled(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete price increases.");
      setDeleteOpen(false);
    }
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "VendorPriceMaster.xlsx",
      sheetName: "Vendor Price Master",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const loadPriceIncrease = async () => {
    gridRef?.current?.api?.showLoadingOverlay();
    try {
      if ((fromDate, toDate)) {
        const list = await OAuthService.getList(
          `${priceIncreaseUrl}/search/findByValidFromBeforeAndValidToAfter?fromDate=${fromDate}&toDate=${toDate}`,
        );
        setRowData(list.data._embedded.vendorPriceIncreases);
      } else {
        const list = await OAuthService.getList(
          `${priceIncreaseUrl}?page=0&size=1000`,
        );
        setRowData(list.data._embedded.vendorPriceIncreases);
      }

      gridRef?.current?.api?.hideOverlay();
    } catch (err) {
      gridRef?.current?.api?.hideOverlay();
      toast.error(err?.response?.data?.errorMessage || err.message);
    }
  };
  useEffect(() => {
    loadPriceIncrease();
  }, [fromDate, toDate]);
  useEffect(() => {
    const getCustomersList = async () => {
      const token =
        localStorage &&
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      let result = [];
      try {
        if (
          token?.scope?.includes("ROLE_IAM") &&
          !(
            token?.scope?.includes("ROLE_ADMIN") ||
            token?.scope?.includes("ROLE_SOPDIR")
          )
        ) {
          const discountURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
          const partners = await OAuthService.getList(
            discountURL + `/getcompaniesbyiamterritory`,
          );
          result = partners?.data
            ?.filter((data) => data.active && data.customerType === "REGULAR")
            ?.map((value) => ({
              label: `${value.id} - ${value.shortKey} - ${value.countryCode}`,
              value: value.id,
            }));
        } else {
          const partners = await OAuthService.getList(
            url + `/search/findByCustomerType?customerType=REGULAR`,
          );
          result = partners?.data?._embedded?.companies?.map((value) => ({
            label: `${value.id} - ${value.shortKey} - ${value.countryCode}`,
            value: value.id,
          }));
        }
      } catch (err) {
        console.error("Error loading customers", err);
      }
      setCustomerOptions(result || []);
      customerOptionsRef.current = result;
    };

    getCustomersList();
  }, []);
  const getOrderCategoryList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;
    try {
      const orderCategories = await OAuthService.getList(url + `?size=1000`);
      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return {
            value: value.name,
            label: value.name,
            name: value.displayName,
          };
        },
      );
      setOrderCategoryOptions([{ value: "ALL", label: "ALL" }, ...result]);
    } catch (err) {
      toast.error(err?.response?.data?.errorMessage || err.message);
    }
  };
  useEffect(() => {
    getOrderCategoryList();
  }, []);
  const findOption = (options, pastedValue) => {
    const value = pastedValue?.toString().trim().toUpperCase();

    return options.find((opt) => {
      const label = opt.label?.toUpperCase();
      const optValue = opt.value?.toString().toUpperCase();

      return label === value || optValue === value;
    });
  };
  const warningShown = useRef(false);

  const showWarning = (msg) => {
    if (warningShown.current) return;

    toast.warning(msg);
    warningShown.current = true;

    setTimeout(() => {
      warningShown.current = false;
    }, 500);
  };
  const processCellFromClipboard = useCallback(
    (params) => {
      const colId = params.column.getColId();
      const pastedValue = params.value?.toString().trim().toUpperCase();

      if (colId === "customerId") {
        const customer = findOption(customerOptions, pastedValue);

        if (!customer) {
          showWarning("Invalid Customer copied");
          params.node.setDataValue("customerId", "");
          return "";
        }

        params.node.setDataValue("customerId", customer.value);
        return customer.value;
      }

      if (colId === "vendorId") {
        let raw = params.value;

        if (!raw) return [];

        const text = Array.isArray(raw) ? raw.join(",") : raw.toString();

        const values = text
          .split(/,|\n|;/)
          .map((v) => v.trim())
          .filter(Boolean);

        const matched = values
          .map((val) => findOption(vendorOptions, val.toUpperCase()))
          .filter(Boolean)
          .map((opt) => opt.value);

        const unique = [...new Set(matched)];

        if (unique.length === 0) {
          showWarning("Invalid Vendor(s) pasted");
          params.node.setDataValue("vendorId", []);
          validateSaveButton();
          return [];
        }

        if (!params.node.isSelected()) {
          params.node.setSelected(true);
        }

        setTimeout(() => {
          params.api?.refreshCells({ rowNodes: [params.node] });
          validateSaveButton();
        }, 0);

        return unique;
      }

      if (colId === "orderCategories") {
        let raw = params.value;

        if (!raw) return [];

        const text = Array.isArray(raw) ? raw.join(",") : raw.toString();

        const values = text
          .split(/,|\n|;/)
          .map((v) => v.trim())
          .filter(Boolean);

        const matched = values
          .map((val) =>
            orderCategoryOptions.find(
              (opt) =>
                opt.value?.toUpperCase() === val.toUpperCase() ||
                opt.label?.toUpperCase() === val.toUpperCase(),
            ),
          )
          .filter(Boolean)
          .map((opt) => opt.value);

        const unique = [...new Set(matched)];

        if (unique.length === 0) {
          showWarning("Invalid Order Categories pasted");
          params.node.setDataValue("orderCategories", []);
          validateSaveButton();
          return [];
        }

        if (!params.node.isSelected()) {
          params.node.setSelected(true);
        }

        setTimeout(() => {
          params.api?.refreshCells({ rowNodes: [params.node] });
          validateSaveButton();
        }, 0);

        return unique;
      }

      return params.value;
    },
    [customerOptions, vendorOptions, orderCategoryOptions, validateSaveButton],
  );

  const handleFromDateChange = (date) => {
    setFromDate(date ? moment(date).format("YYYY-MM-DD") : null);
  };

  const handleToDateChange = (date) => {
    setToDate(date ? moment(date).format("YYYY-MM-DD") : null);
  };
  const columnDefs = [
    {
      headerName: "Sr No",
      field: "srNo",
      colId: "srNo",
      pinned: "left",
      minWidth: 65,
      maxWidth: 65,
      editable: false,
      filter: false,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      cellRenderer: (params) => {
        return params.node.rowIndex + 1;
      },
    },
    {
      field: "customerId",
      headerName: "Customer*",
      type: "editableColumn",
      minWidth: 150,
      cellEditor: CustomerIdEditorComponent,
      cellEditorParams: {
        customerOptions,
      },
      valueFormatter: (params) => {
        const option = customerOptionsRef.current?.find(
          (opt) => opt.value === params.value,
        );
        return option ? option.label : params.value;
      },
    },
    {
      field: "vendorId",
      headerName: "Vendor*",
      type: "editableColumn",
      minWidth: 150,
      cellEditor: MultipleVendorEditorComponent,
      cellEditorParams: {
        vendorOptions,
      },
      processCellForClipboard: (params) => {
        if (params.column.getColId() === "vendorId") {
          const value = params.value;

          if (Array.isArray(value)) {
            return value
              .map(
                (id) =>
                  vendorOptionsRef.current?.find((opt) => opt.value === id)
                    ?.label || id,
              )
              .join(", ");
          }

          return value;
        }

        return params.value;
      },
      valueFormatter: ({ value }) => {
        if (!Array.isArray(value) || value.length === 0) return value || "";

        if (value.length === 1 && value[0] === "ALL") {
          return "ALL";
        }

        const realVendorValues = (vendorOptionsRef.current || [])
          .filter((opt) => opt.value !== "ALL")
          .map((opt) => opt.value);

        const isEveryVendorSelected =
          realVendorValues.length > 0 &&
          realVendorValues.every((v) => value.includes(v)) &&
          value.length === realVendorValues.length;

        if (isEveryVendorSelected) {
          return "ALL";
        }

        return value
          .map(
            (id) =>
              vendorOptionsRef.current?.find((opt) => opt.value === id)
                ?.label || id,
          )
          .join(", ");
      },
    },
    {
      field: "orderCategories",
      headerName: "Order Categories*",
      type: "editableColumn",
      minWidth: 200,
      cellEditor: MultipleOrderCategoryEditorComponent,
      cellEditorParams: {
        orderCategoryOptions,
      },
      processCellForClipboard: (params) => {
        if (params.column.getColId() === "orderCategories") {
          const value = params.value;

          if (Array.isArray(value)) {
            return value.join(", ");
          }

          return value;
        }

        return params.value;
      },
      valueFormatter: ({ value }) => {
        if (!Array.isArray(value) || value.length === 0) return value || "";

        if (value.length === 1 && value[0] === "ALL") {
          return "ALL";
        }

        const realCategoryValues = orderCategoryOptions
          .filter((opt) => opt.value !== "ALL")
          .map((opt) => opt.value);

        const isEveryCategorySelected =
          realCategoryValues.length > 0 &&
          realCategoryValues.every((v) => value.includes(v)) &&
          value.length === realCategoryValues.length;

        if (isEveryCategorySelected) {
          return "ALL";
        }

        return value.join(", ");
      },
    },
    {
      field: "validFrom",
      headerName: "Valid From*",
      type: "editableColumn",
      minWidth: 130,
      cellEditor: DateFromEditorComponent,
      cellRenderer: handleDateFormat,
    },
    {
      field: "validTo",
      headerName: "Valid To*",
      type: "editableColumn",
      minWidth: 130,
      cellEditor: DateToEditorComponent,
      cellRenderer: handleDateFormat,
    },
    {
      headerName: "Payable",
      children: [
        {
          field: "wg1PayablePriceIncrease",
          headerName: "WG1 Payable Price Increase*",
          type: "editableColumn",
          minWidth: 150,
          cellStyle: { backgroundColor: "#2f765f", color: "#fff" },
          cellRenderer: showDiscountPercent,
          cellEditor: NumericCellEditor,
        },
        {
          field: "wg2PayablePriceIncrease",
          headerName: "WG2 Payable Price Increase*",
          type: "editableColumn",
          minWidth: 150,
          cellStyle: { backgroundColor: "#2f765f", color: "#fff" },
          cellRenderer: showDiscountPercent,
          cellEditor: NumericCellEditor,
        },
      ],
    },
  ];
  const onBtCopyRow = useCallback(
    (event) => {
      const api = gridRef.current?.api;
      if (!api) return;

      const selectedRows = api.getSelectedRows();

      const rowsToCopy =
        selectedRows && selectedRows?.length > 0
          ? selectedRows
          : event?.node?.data
          ? [event.node.data]
          : [];

      if (!rowsToCopy?.length) return;

      const insertIndex = api.getDisplayedRowCount();

      const copiedRows = rowsToCopy.map((data) => ({
        ...data,
        id: undefined,
        isNew: true,
        isEdited: false,
      }));

      api.applyTransaction({
        add: copiedRows,
        addIndex: insertIndex,
      });

      setRowData((prev) => [...prev, ...copiedRows]);
      setTimeout(() => {
        validateSaveButton();
      }, 100);
      setTimeout(() => {
        const firstNewRowIndex = insertIndex;

        api.setFocusedCell(firstNewRowIndex, "customerId");
        api.startEditingCell({
          rowIndex: firstNewRowIndex,
          colKey: "customerId",
        });
      }, 100);
      setTimeout(() => {
        validateSaveButton();
      }, 100);
    },
    [rowData],
  );
  const getContextMenuItems = useCallback(
    (event) => {
      const hasSelection = selectedRows && selectedRows?.length > 0;

      return [
        {
          name: "Add New Price Increase",
          icon: '<span><i class="material-icons" style="font-size: 18px">add</i></span>',
          disabled: false,
          action: handleAddRow,
        },
        {
          name: "Edit Price Increase",
          icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
          disabled: selectedRows?.length !== 1,
          action: () => {
            const api = gridRef.current.api;
            const selectedNodes = api.getSelectedNodes();
            if (selectedNodes?.length > 0) {
              startEditRow(selectedNodes[0]);
              return;
            }
          },
        },

        {
          name: "Copy Price Increase",
          icon: '<span><i class="material-icons" style="font-size: 18px">content_copy</i></span>',
          disabled: !hasSelection,
          action: () => onBtCopyRow(event),
        },

        {
          name: "Delete Price Increase",
          icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
          disabled: !hasSelection,
          action: () => setDeleteOpen(true),
        },

        "separator",
        "export",
        "chartRange",
      ];
    },
    [selectedRows, rowData],
  );
  const getSaveTooltipMessage = () => {
    if (isSaveEnabled) return "Save Price Increase";

    const changedRows = rowData.filter(isRowChanged);

    if (changedRows.length === 0) {
      return "No records have been added or updated yet.";
    }

    const selectedIds = new Set(
      (selectedRows || []).map((row) => row.id ?? row),
    );
    const unselectedChangedRows = changedRows.filter(
      (row) => !selectedIds.has(row.id ?? row),
    );

    if (unselectedChangedRows.length > 0) {
      return "Please select the updated records before saving.";
    }

    return "Please fill all required fields before saving.";
  };
  const FilterField = ({ children }) => (
    <Box
      sx={{
        display: { xs: "flex", md: "contents" },
        flexDirection: { xs: "column" },
        width: { xs: "100%", md: "auto" },
      }}
    >
      {children}
    </Box>
  );

  const discountListDropdown = () => (
    <>
      <FilterField>
        <CustomDatePicker
          label="From"
          placeholder="Date"
          className="h-[30px]"
          sx={{
            width: { xs: "100%", md: "auto" },
            "& .MuiInputBase-root": { height: "30px", minHeight: "30px" },
          }}
          format="dd-MM-yyyy"
          value={fromDate ? new Date(fromDate) : null}
          handleChange={handleFromDateChange}
          componentsProps={{ actionBar: { actions: ["clear"] } }}
        />
      </FilterField>

      <FilterField>
        <CustomDatePicker
          label="To"
          placeholder="Date"
          className="h-[30px]"
          sx={{
            width: { xs: "100%", md: "auto" },
            "& .MuiInputBase-root": { height: "30px", minHeight: "30px" },
          }}
          format="dd-MM-yyyy"
          value={toDate ? new Date(toDate) : null}
          handleChange={handleToDateChange}
          componentsProps={{ actionBar: { actions: ["clear"] } }}
        />
      </FilterField>

      <Tooltip title={"Add New Price Increase"}>
        <Button variant="contained" color="secondary" onClick={handleAddRow}>
          <FuseSvgIcon>heroicons-solid:plus</FuseSvgIcon>
        </Button>
      </Tooltip>

      <Tooltip title={getSaveTooltipMessage()}>
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setSaveOpen(true)}
            disabled={!isSaveEnabled}
          >
            <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
          </Button>
        </span>
      </Tooltip>

      <Tooltip title={"Edit Price Increase"}>
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleEditRow}
            disabled={!selectedRows || selectedRows.length !== 1}
          >
            <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
          </Button>
        </span>
      </Tooltip>

      <Tooltip title={"Delete Price Increase"}>
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setDeleteOpen(true)}
            disabled={!selectedRows || selectedRows.length === 0}
          >
            <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
          </Button>
        </span>
      </Tooltip>
    </>
  );
  return (
    <>
      <ListPageHeader
        componentName="Vendor Price Increase List"
        onBtExport={onBtExport}
        pageName="Vendor Price Increase List"
        headerInputFields={discountListDropdown()}
        gridRef={gridRef}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          minHeight: 0,
          minWidth: 0,
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            minHeight: 400,
            minWidth: 0,
            width: "100%",
            height: isMobile ? "calc(100vh - 260px)" : "calc(100vh - 180px)",
            overflow: "hidden",
          }}
        >
          <AgGridTable
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            gridRef={gridRef}
            rowSelection="multiple"
            onSelectionChanged={onSelectionChanged}
            editable={true}
            editType={"fullRow"}
            suppressClickEdit={false}
            saveGridStateName={"vendorPriceIncreaseList"}
            onCellValueChanged={onCellValueChanged}
            autoHeaderHeight
            wrapHeaderText
            rowHeight={36}
            getContextMenuItems={getContextMenuItems}
            processCellFromClipboard={processCellFromClipboard}
            onPasteEnd={handlePasteEnd}
            rowGroupPanelShow="never"
          />
        </div>
      </div>

      <Dialog open={saveOpen} onClose={() => setSaveOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to save price increase ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveDiscount}>Yes</Button>
          <Button onClick={() => setSaveOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to Delete price increase ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDiscount}>Yes</Button>
          <Button onClick={() => setDeleteOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VendorPriceIncrease;
